import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaFolderOpen }    from '@react-icons/all-files/fa/FaFolderOpen';
import { FaProjectDiagram } from '@react-icons/all-files/fa/FaProjectDiagram';
import { FaCog }            from '@react-icons/all-files/fa/FaCog';
import { FaHome }           from '@react-icons/all-files/fa/FaHome';
import { FaPlus }           from '@react-icons/all-files/fa/FaPlus';
import Breadcrumb    from '../../../../commons/Breadcrumb';
import PageHeader    from '../../../../commons/PageHeader';
import PageAlert, { usePageAlert } from '../../../../commons/PageAlert';
import Confirm, { useConfirm }     from '../../../../commons/Confirm';
import { EditButton, DeleteButton, RenderActions } from '../../../../commons/DataGridActions';
import ProfaseDataGrid from '../../../../commons/Datagrid';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { getEntities, deleteEntity, reset } from '../../../../manager/categoria-actividad.reducer';

const BASE = '/configuracion/workflow/categoria-actividad';

export default function CategoriaActividadPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const topRef   = useRef<HTMLDivElement>(null);

  const entities      = useAppSelector(s => s.categoriaActividad.entities);
  const totalItems    = useAppSelector(s => s.categoriaActividad.totalItems);
  const loading       = useAppSelector(s => s.categoriaActividad.loading);
  const updating      = useAppSelector(s => s.categoriaActividad.updating);
  const updateSuccess = useAppSelector(s => s.categoriaActividad.updateSuccess);

  const [rows, setRows]             = useState<any[]>([]);
  const [lastParams, setLastParams] = useState<any>(null);

  const { alert, showToast }                               = usePageAlert();
  const { confirmConfig, ask, dismiss, setConfirmLoading } = useConfirm();

  useEffect(() => {
    const msg = (location.state as any)?.successMsg;
    if (msg) { showToast('success', msg); window.history.replaceState({}, ''); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (updateSuccess) {
      dispatch(reset());
      dismiss();
      if (lastParams) dispatch(getEntities(lastParams));
      showToast('success', 'Categoría de actividad eliminada correctamente.');
    }
  }, [updateSuccess]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { setConfirmLoading(updating); }, [updating]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { setRows(entities ?? []); }, [entities]);

  

  const fetchData = (params: any) => {
    setLastParams(params);
    dispatch(getEntities(params));
  };

  const renderActions = (params: any) => (
    <RenderActions>
      <EditButton onClick={() => navigate(`${BASE}/${params.row.id}/edit`)} />
      <DeleteButton onClick={() => {
        ask(
          <>¿Confirmas que deseas eliminar <strong>{params.row.nombre}</strong>? Esta acción no se puede deshacer.</>,
          () => dispatch(deleteEntity(params.row.id)),
          { title: 'Eliminar Categoría de Actividad', confirmLabel: 'Eliminar', variant: 'danger' },
        );
        topRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }} />
    </RenderActions>
  );
  
  const objCell = (params: any) =>
    params.value?.descripcion ?? params.value?.id ?? '—';

  const cols = [
    { field: 'id', headerName: 'ID', flex: 0.5 },
    {
      field: 'nombre',
      headerName: 'Nombre',
      flex: 2,
      renderCell: (p: any) => p.row.nombre ?? p.row.descripcion ?? '—',
    },
    { field: 'descripcion', headerName: 'Descripción', flex: 3 },
    { field: 'tipoActividad', headerName: 'Tipo Actividad', flex: 3, renderCell: objCell },
    { field: '__actions', headerName: '', flex: 1, renderCell: renderActions },
  ];

  const filters = [
    { label: 'ID', name: 'id' },
    { label: 'Nombre', name: 'nombre' },
    { label: 'Descripción', name: 'descripcion' },
  ];

  return (
    <div style={g.page} ref={topRef}>
      <Breadcrumb items={[
        { label: 'Inicio',                 to: '/',                       icon: <FaHome /> },
        { label: 'Configuración',          to: '/configuracion',          icon: <FaCog /> },
        { label: 'Workflow',               to: '/configuracion/workflow', icon: <FaProjectDiagram /> },
        { label: 'Categoría de Actividad',                                icon: <FaFolderOpen /> },
      ]} />

      <PageHeader
        icon={<FaFolderOpen />}
        iconColor="#f59e0b"
        title="Categoría de Actividad"
        subtitle="Gestión de categorías de actividad"
        action={{
          label: <><FaPlus style={{ marginRight: 6 }} />Nueva Categoría</>,
          onClick: () => navigate(`${BASE}/new`),
          color: '#f59e0b',
        }}
      />

      <Confirm config={confirmConfig} />
      {alert && <PageAlert alert={alert} />}

      <ProfaseDataGrid
        cols={cols}
        title=""
        filters={filters}
        fetch={fetchData}
        rowCount={totalItems}
        loading={loading}
        rows={rows}
      />
    </div>
  );
}

const g: Record<string, React.CSSProperties> = {
  page: { display: 'flex', flexDirection: 'column', gap: 24 },
};
